import type { FUSportsLivescoreScore } from "fansunited-data-layer";
import { getPeriodScores, type PeriodScoreEntry } from "@/views/livescore/utils/livescore";

export type PeriodScore = PeriodScoreEntry;

/**
 * Extract per-period entries from a livescore event's score array. Labels
 * are generated as `${prefix}1`, `${prefix}2`, etc. Aggregate keys
 * (`result`, `full_time`, `half_time`) are skipped. Entries where both
 * sides are non-numeric are filtered out.
 *
 * `maxRegulationCount` caps regulation periods only — overtime and penalty
 * entries always render on top (e.g. basketball Q1-Q4 + OT).
 */
export function getBreakdownPeriods(
    score: FUSportsLivescoreScore[] | undefined,
    labelPrefix: string,
    maxRegulationCount?: number
): PeriodScore[] {
    return getPeriodScores(score, labelPrefix, maxRegulationCount);
}
